import { c as _c } from "react/compiler-runtime";
import { DevFeaturesDialogButton } from "@components/dev-features-dialog/dev-features-dialog-button";
import { FaroHelpCenterMenu } from "@components/header/faro-help-center-menu";
import { UserMenu } from "@components/header/user-menu";
import { ProgressOverviewMenu } from "@components/progress-overview/progress-overview-menu";
import { useMediaQueryList } from "@hooks/use-media-query";
import { Grid } from "@mui-wrapper";
import { useAppSelector } from "@store/store-helper";
import { loggedInUserSelector } from "@store/user/user-selector";
/** Content for the right side of layout header */
export function HeaderLayoutRight(t0) {
  const $ = _c(14);
  const {
    shouldShowProgressOverviewMenu,
    shouldShowUserMenu
  } = t0;
  const {
    isScreenSmOrSmaller
  } = useMediaQueryList();
  const loggedInUser = useAppSelector(loggedInUserSelector);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      alignItems: "center",
      justifyContent: "right"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = isScreenSmOrSmaller ? "0.25rem" : "1rem";
  let t3;
  if ($[1] !== t2) {
    t3 = {
      alignItems: "center",
      gap: t2
    };
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  let t5;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <DevFeaturesDialogButton />;
    t5 = <FaroHelpCenterMenu />;
    $[3] = t4;
    $[4] = t5;
  } else {
    t4 = $[3];
    t5 = $[4];
  }
  let t6;
  if ($[5] !== loggedInUser || $[6] !== shouldShowProgressOverviewMenu) {
    t6 = shouldShowProgressOverviewMenu && loggedInUser && <ProgressOverviewMenu />;
    $[5] = loggedInUser;
    $[6] = shouldShowProgressOverviewMenu;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== shouldShowUserMenu) {
    t7 = shouldShowUserMenu && <UserMenu />;
    $[8] = shouldShowUserMenu;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== t3 || $[11] !== t6 || $[12] !== t7) {
    t8 = <Grid container={true} sx={t1}><Grid container={true} sx={t3}>{t4}{t5}{t6}{t7}</Grid></Grid>;
    $[10] = t3;
    $[11] = t6;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  return t8;
}